import type { FaireProductEntity } from "../../entity_types/product";

export const p_7rj2xr6jsu: FaireProductEntity = {
  token: "p_7rj2xr6jsu",
  type: "product",
  name: "Estrella Hoops - 18K Gold Plated or Stainless Steel",
  brandToken: "b_5fhorwgw5m",
  brandName: "Peter and June",
  imageUrl:
    "https://cdn.faire.com/fastly/9b5fb55bcd65ec1aa3704970da4a198f82492f782ebbf2b5f9c2277deb82a47e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d039320e1fdb894b9dd1ade0c68aed223f73790746acb7c07ad56cd32a9c0bf1.jpeg",
  ],
  priceDollars: 14,
  description:
    "• 18k gold plated over stainless steel\n• or straight stainless steel\n• waterproof\n• nickel / lead free\n• made with materials ethically sourced",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:42.590Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
